<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Comprobante">
          <b-table 
              small 
              responsive="sm" 
              :items="remitoDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>
        
        <b-card header="Detalle del Remito">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="remitoRenglonesDescripcionDatos" 
              :fields="fieldsRenglonesDescripcion">
            <template v-slot:cell(valorDeclarado)="data">
              {{ data.item.valorDeclarado | moneda }}
            </template>
          </b-table>
        </b-card>

        <b-card header="Evaluación al Proveedor" v-if="remitoEvaluacionDatos.length != 0">
          <b-table 
              class="data-display"
              small 
              responsive="sm" 
              :items="remitoEvaluacionDatos" 
              :fields="fields">
            <template v-slot:cell(valor)="data">
              {{ formattedData(data.item) }}
            </template>
          </b-table>
        </b-card>        
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goList">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'remito/getField',
  mutationType: 'remito/updateField',
});

export default {
  name: 'RemitoData',
  components: {
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data: () => {
    return {
      ventaId: 0,
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],
      fieldsRenglonesDescripcion: [
        {
          key: 'cantidad',
        },
        {
          key: 'descripcion',
          label: 'Descripción'
        },
      ],
      // fieldsPresupuestosInternos: [
      //   {
      //     key: 'presupuestoInternoId',
      //     label: 'Nro.Presupuesto'
      //   },
      //   {
      //     key: 'accion',
      //     label: 'Presupuesto'
      //   },
      // ],
      msjModalVisible: false,
      msjModal: '',
      msjModalVariant: 'light'
    }
  },
  created() {
    this.remitoId = this.$route.params.id;

    this.$store.dispatch('remito/getDatos', this.remitoId)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'remitoDatos',
      'remitoRenglonesDescripcionDatos',
      'remitoPresupuestosInternosDatos',
      'remitoEvaluacionDatos'
    ]),
  },
  methods: {
    goList() {
      this.$router.go(-1);
      // this.$router.push({ name: 'Remitos' });
    },
  }
}
</script>
